var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.hasPermission
    ? _c(
        "div",
        {
          staticClass: "project-portfolio",
        },
        [
          _c(
            "div",
            {
              staticClass: "container-fluid",
            },
            [_c("project-portfolio-table")],
            1
          ),
        ]
      )
    : _c("div", [
        _c(
          "div",
          {
            staticClass: "container-fluid",
          },
          [
            _c("access-denied-modal", {
              on: {
                clickedcanceleditstate: _vm.onClickCancel,
              },
            }),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }